export function getParam(name) {
  const params = new URLSearchParams(window.location.search);
  const value = params.get(name);

  if (value !== null) {
    return value.split('?')[0] || 0;
  }

  const results = new RegExp('[?&]' + name + '=([^&#?]*)').exec(window.location.href);
  if (results == null) {
    return null;
  } else {
    return results[1] || 0;
  }
}
